import { ContentPane } from "@/components/ContentPane.tsx";
import { EnabledDisabled } from "@/components/EnabledDisabled.tsx";
import { SectionHeader } from "@/components/SectionHeader.tsx";
import { WTable, WTableBody } from "@/components/table/WTable.tsx";
import { MaintenanceEditModal } from "@/modules/services/kubernetes/MaintenanceEditModal.tsx";
import { Trans } from "@lingui/react/macro";
import type { ManagedKubernetesService } from "@warrenio/api-spec/spec.oats.gen";
import { notNull } from "@warrenio/utils/notNull";

export function MaintenanceContent({ item }: { item: ManagedKubernetesService }) {
    const { properties } = item;

    const formatTime = (data: string, zone?: boolean): any => {
        const time = data.slice(0, 6);
        const timezone = Number(data.slice(6, data.length - 2));

        return zone
            ? `${timezone > 0 ? `+${timezone}:00` : timezone === 0 ? "GMT" : `${timezone}:00`}`
            : `${Number(time) / 10000}:00`;
    };

    return (
        <ContentPane className="VStack gap-4">
            <SectionHeader
                title={<Trans>Maintenance</Trans>}
                description={
                    <Trans>
                        Automatic system-level backups are enabled. Use the backup images to restore your service.
                        Backups will be stored for 7 days, meaning you will have 7 latest backups.
                    </Trans>
                }
            />

            <WTable afterTable={<MaintenanceEditModal item={item} />}>
                <WTableBody>
                    {properties?.spec?.maintenance.timeWindow && (
                        <>
                            <tr>
                                <th>
                                    <Trans>Start time</Trans>
                                </th>
                                <td>{formatTime(notNull(properties?.spec?.maintenance.timeWindow.begin))}</td>
                            </tr>
                            <tr>
                                <th>
                                    <Trans>Timezone</Trans>
                                </th>
                                <td>{formatTime(notNull(properties?.spec?.maintenance.timeWindow.begin), true)}</td>
                            </tr>
                        </>
                    )}
                    {properties?.spec?.maintenance.autoUpdate && (
                        <>
                            <tr>
                                <th>
                                    <Trans>Operating system Auto update</Trans>
                                </th>
                                <td>
                                    <EnabledDisabled
                                        value={properties.spec.maintenance.autoUpdate.machineImageVersion}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <Trans>Kubernetes Patch Version Auto update</Trans>
                                </th>
                                <td>
                                    <EnabledDisabled value={properties.spec.maintenance.autoUpdate.kubernetesVersion} />
                                </td>
                            </tr>
                        </>
                    )}
                </WTableBody>
            </WTable>
        </ContentPane>
    );
}
